import { render, staticRenderFns } from "./ListPreferenciaPage.vue?vue&type=template&id=1403cae1"
import script from "./ListPreferenciaPage.vue?vue&type=script&lang=js"
export * from "./ListPreferenciaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports